export default __webpack_public_path__ + "static/media/LeaderDashboard.52df01d4.svg";